import {Component, Inject } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "@auth0/auth0-angular";
import {DOCUMENT} from "@angular/common";
import {UrlBuilder} from "../url-builder/url.builder";


export class MMenuListItem {
  text: string = "";
  icon: string = "";
  isDisabled: boolean = false;  //
  clientOnly: boolean = true;   // This option can only be used if there is a valid client
  routerLink: string = "";
}


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})

export class MenuComponent {

  menuListItems : MMenuListItem[] =
    [
      {
        text: 'List',
        icon: 'detail-section',
        isDisabled:false,
        clientOnly:false,
        routerLink: "list"
      },

      // { text: 'Heatmap',
      //   icon: 'arrow-root',
      //   isDisabled:false,
      //   clientOnly:true,
      //   routerLink: "heatmap"
      // },
      //
      { text: 'Complex Devices',
        icon: 'arrow-root',
        isDisabled:false,
        clientOnly:true,
        routerLink: "complex"
      },
      { text: 'Fastlink monitor',
        icon: 'arrow-root',
        isDisabled:false,
        clientOnly:true,
        routerLink: "fastlinkmonitor"
      },
      {
        text: 'Information',
        icon: 'marker-pin',
        isDisabled:false,
        clientOnly: true,
        routerLink: "information"
      },
      {
        text: 'Cards',
        icon: 'detail-section',
        isDisabled:false,
        clientOnly:true,
        routerLink: "cards"
      },
      { text: 'Digital Out',
        icon: 'logout',
        isDisabled:false,
        clientOnly:true,
        routerLink: "digitalout"
      },
      { text: 'Digital In',
        icon: 'login',
        isDisabled:false,
        clientOnly:true,
        routerLink: "digitalin"
      },
      { text: 'Measurements',
        icon: 'signature',
        isDisabled:false,
        clientOnly:true,
        routerLink: "measurements"
      },


      { text: 'Frequency',
        icon: 'arrows-dimensions',
        isDisabled:false,
        clientOnly:true,
        routerLink: "frequency"
      },
      { text: 'Counters',
        icon: 'arrow-root',
        isDisabled:false,
        clientOnly:true,
        routerLink: "counter"
      },
      { text: 'Analog Out',
        icon: 'plus-outline',
        isDisabled:false,
        clientOnly:true,
        routerLink: "analogout"
      },
      { text: 'Analog In',
        icon: 'minus-outline',
        isDisabled:false,
        clientOnly:true,
        routerLink: "analogin"
      },
      { text: 'Slot Measurements',
        icon: 'indent',
        isDisabled:false,
        clientOnly:true,
        routerLink: "measurementsslots"
      },
      { text: 'Calibration',
        icon: 'signature',
        isDisabled:false,
        clientOnly:true,
        routerLink: "calibration"
      },
      { text: 'QUEUE',
        icon: 'plus-outline',
        isDisabled:false,
        clientOnly:true,
        routerLink: "queue"
      },
      { text: 'Modbus',
        icon: 'gears',
        isDisabled:false,
        clientOnly:true,
        routerLink: "modbus"
      },
      { text: 'Mapped Servo',
        icon: 'pan',
        isDisabled:false,
        clientOnly:true,
        routerLink: "mappedservo"
      },
      { text: 'Analyser',
        icon: 'settings',
        isDisabled:false,
        clientOnly:true,
        routerLink: "analyser"
      },
      { text: 'Wifi Info',
        icon: 'gears',
        isDisabled:false,
        clientOnly:true,
        routerLink: "wifi"
      },

      { text: 'Dmesg log',
        icon: 'file-presentation',
        isDisabled:false,
        clientOnly:true,
        routerLink: "dmesglog"
      },
      { text: 'Climate log',
        icon: 'file-presentation',
        isDisabled:false,
        clientOnly:true,
        routerLink: "climatelog"
      },
      { text: 'User profile',
        icon: 'user',
        isDisabled:false,
        clientOnly:true,
        routerLink: "user"
      },

    ];
  url:  UrlBuilder;
  public icon = "cog";
  profileJson: string = "";
  token: string = "";

  constructor(@Inject(DOCUMENT) public document: Document, public auth: AuthService, private router: Router)
  {
    this.url = new UrlBuilder();
  }

  HandleMenuClick(item: MMenuListItem): void {
    this.router.navigate([item.routerLink]);
  }


  navigate(path: string) {
    this.router.navigate([{outlets: {primary: path}}]);
  }

  GetMenuItems() {
    let urlBuilder: UrlBuilder = new UrlBuilder();

    return this.menuListItems;

    if(urlBuilder.GetCurrentClient().length < 2)
        return this.menuListItems.filter(item => !item.clientOnly);
    else
        return this.menuListItems.filter(item => item.clientOnly);
  }
}
